import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import { select, Store } from '@ngrx/store';
import { getAllCountries, ParticleState } from '@shared/store/reducers/particle.reduer';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransmissionService } from '../../../services/transmission.service';
import {Dac6ReporterApiService} from "@features/dac6-reporter/services/dac6-reporter.service";
import {MagicLinkModel} from "@shared/models/platform-tool-models";

@Component({
    standalone: false,
    selector: 'particle-upload-report-for-transmission',
  templateUrl: './upload-report-for-transmission.component.html',
  styleUrls: ['./upload-report-for-transmission.component.scss']
})
export class UploadReportForTransmissionComponent implements OnInit, IDialogView, AfterViewInit,OnDestroy {

  data: DialogModel;
  isIndividualResponse: boolean;
  showResponseOption: boolean;
  responseType: string;
  allowCreateNewRecord: boolean;
  legend: string = 'DAC6 Report (.XML)';
  required: boolean = true;
  fileName: string;
  file: File = null;
  fileExtension: string;
  fileError: string;
  formData: FormData;
  editable: any;
  supportedFileExtensions: string[] = ['.xml'];
  @ViewChild('fileInput') searchInput: ElementRef;
  reportingCountries =  [];
  unsubscribe$ = new Subject<void>();
  filingTypes = [];
  selectedCountryCode: string;
  acceptedFileExtensions: string[];
  encryptionProcess: string;
  notes: string = '';

  constructor(private particleStore: Store<ParticleState>,
              private transmissionService: TransmissionService,
              private dac6ApiService: Dac6ReporterApiService
  ) {

  }

  ngOnInit() {
    // this.particleStore.pipe(select(getAllCountries)).pipe(takeUntil(this.unsubscribe$)).subscribe(countries => {
    //   this.reportingCountries = countries;
    // });
    this.transmissionService.getReportingCountry(this.data.input['endpointName']).pipe(takeUntil(this.unsubscribe$)).subscribe(countries => {
      this.reportingCountries = countries;
    });
    this.transmissionService.getFilingTypeModels('DAC6', this.data.input['endpointName']).pipe(takeUntil(this.unsubscribe$)).subscribe(filingTypes => {
      this.filingTypes = filingTypes;
    });
    this.showResponseOption = this.data.input.showResponseOption;
    this.isIndividualResponse = this.data.input.isIndividualResponse === true;
    this.responseType = this.isIndividualResponse ? 'independent' : 'collaborate';
    this.allowCreateNewRecord = this.data.input.allowCreateNewRecord === true;

    this.formData = new FormData();
  }
  ngAfterViewInit (): void {

  }
  handleCheckbox(event){

  }
  onOkClicked(): boolean {
    this.data.input.importFile = this.file;
    if(this.data.input.identificationNumber && this.data.input.identificationNumber.length){
      this.data.input.additionalData['Identification_1'] = this.data.input.identificationNumber;
    }
    if(this.fileExtension && this.fileExtension.length){
      if (this.selectedCountryCode === 'FR') {
        this.data.input.metaData['Extension'] = 'FVIE';
      } else {
        this.data.input.metaData['Extension'] = this.fileExtension.substring(1).toUpperCase();
      }
    }
    if(this.encryptionProcess && this.data.input.allowEncryption === true){
      this.data.input.metaData['EncryptionProcess'] = this.encryptionProcess;
    }
    if(this.selectedCountryCode === 'FR' && this.fileExtension.toLowerCase() === '.fvie'){
      this.data.input.hasXmlValidation = false;
    }
    return true;
  }

  initiateTextArea() {
    this.editable = document.getElementById('upload-file-dialog-textarea');
    this.editable.innerText = this.fileName;
    this.editable.addEventListener('input', () => {
      this.fileName = this.editable.innerText;
    });
  }

  onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.updateFileData(evt.dataTransfer.files);
    this.removeDragData(evt);
  }

  onFileSelect(event) {
    this.updateFileData(event.target.files);
    this.searchInput.nativeElement.value = null;
  }

  onDragOver(evt) {
    evt.preventDefault();
  }

  updateFileData(files: File[]) {

    this.file = this.getDefaultFile(files);
    let fileExtension = (this.file) ? this.file.name.slice(this.file.name.lastIndexOf('.'), this.file.name.length) : null;

    if(!this.supportedFileExtensions.find(ext=>ext===fileExtension)) {
      this.file = null;
      this.fileName = null;
      this.fileExtension = null;
      this.fileError = 'Only '+this.supportedFileExtensions.toString()+' files are supported';

    } else {

      this.fileName = (this.file) ? this.file.name.slice(0, this.file.name.lastIndexOf('.')) : null;
      this.fileExtension = fileExtension;
    }

    this.initiateTextArea();
    this.updateFormData();
  }

  updateFormData() {
    this.formData = new FormData();
    this.formData.append('file', this.file);
    this.formData.append('fileName', this.fileName + this.fileExtension);
    //this.formData.append('parentId', this.data.parentId);
    //this.formData.append('driveId', this.data.driveId);
    this.formData.append('overwrite', 'false');
  }

  getDefaultFile(files) {
    if (files.length > 0) {
      if (this.fileError) {
        this.fileError = null;
      }
      return files[0];
    }
    this.fileError = this.legend + ' is required';
  }

  removeFile() {
    this.updateFileData([]);
    this.file = null;
    this.fileName = null;
    this.fileExtension = null;
    if (this.required) {
      this.fileError = this.legend + ' is required';
    }
  }

  removeDragData(ev) {
    console.log('Removing drag data');
    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to remove the drag data
      ev.dataTransfer.items.clear();
    } else {
      // Use DataTransfer interface to remove the drag data
      ev.dataTransfer.clearData();
    }
  }
  onReportingCountrySelectionChange(event){
    this.data.input.allowEncryption = false;
    this.notes = '';
    this.encryptionProcess = '';
    this.selectedCountryCode = event.value;
    this.acceptedFileExtensions = [];
    this.supportedFileExtensions[0] = '.xml';
    this.legend = 'DAC6 Report (.XML)';
    this.dac6ApiService.getAgreementByCountryCode(this.selectedCountryCode,this.data.input['endpointName']).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
      if (response) {
        if(response.acceptedFileExtensions){
          this.acceptedFileExtensions = response.acceptedFileExtensions;
          if(this.acceptedFileExtensions && this.acceptedFileExtensions.length>0){
            this.supportedFileExtensions = [];
            this.supportedFileExtensions.push('.' + this.acceptedFileExtensions[0].toLowerCase());
            this.data.input.fileType = this.acceptedFileExtensions[0];
            this.updateAllowEncryption(this.data.input.fileType);
            this.legend = 'DAC6 Report (.' + this.acceptedFileExtensions[0] + ')';
          }
        }
        if(response.encryptionProcess){
          this.encryptionProcess = response.encryptionProcess;
        }
        if(response.notes){
          this.notes = response.notes;
        }
      }
    });
    if (this.fileExtension) {
      this.removeFile();
      this.isShowOkButton();
    }
    this.data.input.reportingEntityName = '';
  }

  onFileTypeSelectionChange(event) {
    this.supportedFileExtensions = [];
    this.supportedFileExtensions.push('.' + event.value.toLowerCase());
    this.legend = 'DAC6 Report (.' + event.value + ')';
    if (this.fileExtension) {
      this.removeFile();
      this.isShowOkButton();
    }
    this.updateAllowEncryption(event.value);
  }

  updateAllowEncryption(fileType){
    this.data.input.allowEncryption = false;
    if (this.selectedCountryCode === 'FR' && fileType === 'XML') {
      this.data.input.allowEncryption = true;
    }
  }

  onReportingFrequencySelectionChange(event){

  }
  isShowOkButton() {
    let ret = false;
    if(this.file == null) ret = true;
    if(!this.data.input.reportingFrequency || this.data.input.reportingFrequency.length === 0) ret = true;
    if(!this.data.input.reportingCountryCode || this.data.input.reportingCountryCode.length === 0) ret = true;
    if(!this.data.input.reportingEntityName || this.data.input.reportingEntityName.length === 0) ret = true;
    if(this.selectedCountryCode === 'FR' && (!this.data.input.identificationNumber || this.data.input.identificationNumber.length === 0)) ret = true;
    if(this.acceptedFileExtensions && this.acceptedFileExtensions.length && (!this.data.input.fileType || !this.data.input.fileType)) ret = true;
    this.data.isDisabledOkButton = ret;
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
